import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TermsAndConditions = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBack = () => {
    navigate('/');
  };

  return (
    <div className="privacy-policy">
      <div className="privacy-policy-container">
        <button className="back-button" onClick={handleBack}>
          <ArrowLeft size={20} />
          Back to Home
        </button>
        
        <div className="privacy-policy-content">
          <h1>Terms & Conditions</h1>
          <p className="last-updated">Last updated: October 16, 2026</p>
          
          <section>
            <p>
              Welcome to <strong>JustLabs</strong>. These Terms & Conditions ("Terms", "Agreement") govern your access to and use of the website <strong>justlabs.in</strong>, our applications, and our paid software products. This website and the brand JustLabs are owned and operated by <strong>Pankaj Acharya</strong> ("Proprietor", "we", "us", or "our"), an individual and sole proprietor operating in India.
            </p>
            <p>
              By accessing our website or purchasing a license for any of our products, you agree to be bound by these Terms. If you do not agree with any part of these Terms, please do not use our website or purchase our products.
            </p>
          </section>

          <section>
            <h2>1. Scope of Products</h2>
            <p>JustLabs is an independent software product company developing standalone software products:</p>
            <ul>
              <li>
                <strong>JustSolar (Commercial Android Software):</strong> A specialized commercial Android software application for solar EPC companies, rooftop contractors, and site surveyors.
              </li>
              <li>
                <strong>Consumer Utility Android Applications:</strong> Mobile utilities (including JustPDF, JustPrint, JustSaver, and JustConverter) distributed directly through the Google Play Store. These utility apps are governed by their respective store listings and policies.
              </li>
            </ul>
          </section>

          <section>
            <h2>2. JustSolar Product License & Pricing</h2>
            <ul>
              <li>
                <strong>Pricing:</strong> The current one-time lifetime license fee for JustSolar is prominently displayed on the JustSolar product page (<strong>₹1,990 INR</strong> inclusive of all applicable taxes, unless otherwise specified).
              </li>
              <li>
                <strong>Lifetime Access:</strong> Purchase of a JustSolar license grants you a perpetual, non-exclusive, non-transferable license to use the application on one designated Android device. There are no recurring monthly subscription fees.
              </li>
              <li>
                <strong>Restrictions:</strong> You may not decompile, reverse-engineer, modify, redistribute, sublicense, or resell the JustSolar application, APK, or issued license keys.
              </li>
            </ul>
          </section>

          <section>
            <h2>3. Payment & Order Processing</h2>
            <p>
              All online transactions are securely processed through authorized third-party payment gateways.
            </p>
            <ul>
              <li>Prices are listed in Indian Rupees (INR).</li>
              <li>You agree to provide valid, accurate, and complete payment and billing information.</li>
              <li>We do not store your sensitive financial information (such as credit/debit card numbers or bank credentials) on our servers.</li>
            </ul>
          </section>

          <section>
            <h2>4. Delivery & Activation Policy</h2>
            <p>
              <strong>Important Notice on Activation:</strong> License activation is <strong>not instant or automated</strong>.
            </p>
            <ul>
              <li>Upon successful completion of payment, you will immediately receive an official payment receipt.</li>
              <li>Our technical operations team manually reviews the transaction and provisions your unique lifetime license key within <strong>2 to 24 business hours</strong>.</li>
              <li>Your license key, secure APK download link, and setup instructions will be dispatched to the email address provided during checkout.</li>
              <li>If you have not received your activation details within 24 business hours, please reach out directly to <code>pankajacharyaorg@gmail.com</code>.</li>
            </ul>
          </section>

          <section>
            <h2>5. Intellectual Property Rights</h2>
            <p>
              All software, source code, designs, graphics, branding, logos, and written content available on this website and within our applications are the exclusive intellectual property of <strong>Pankaj Acharya</strong> (JustLabs) and are protected by Indian and international copyright and trademark laws.
            </p>
          </section>

          <section>
            <h2>6. Limitation of Liability & Disclaimer</h2>
            <p>
              Our applications and software tools (including solar calculation algorithms, Bill of Materials templates, and electrical estimates) are designed to provide assistance and planning data. Solar PV professionals must perform their own final electrical engineering and structural due diligence prior to physical installation. To the maximum extent permitted by applicable law, JustLabs and Pankaj Acharya shall not be liable for any indirect, incidental, consequential, or punitive damages arising from the use of our software.
            </p>
          </section>

          <section>
            <h2>7. Governing Law and Dispute Resolution</h2>
            <p>
              These Terms and any dispute arising from the purchase or use of our software shall be governed by and construed in accordance with the laws of <strong>India</strong>. Any legal action or proceeding related to this website or our software shall be brought exclusively in the courts of competent jurisdiction in <strong>Ajmer, Rajasthan, India</strong>.
            </p>
          </section>

          <section>
            <h2>8. Contact & Legal Entity Information</h2>
            <div className="contact-info">
              <p>For inquiries, legal notices, or support regarding these Terms:</p>
              <p><strong>Proprietor Legal Name:</strong> Pankaj Acharya</p>
              <p><strong>Business Name:</strong> JustLabs</p>
              <p><strong>Email:</strong> <a href="mailto:pankajacharyaorg@gmail.com">pankajacharyaorg@gmail.com</a></p>
              <p><strong>Support Window:</strong> Monday – Saturday, 9:30 AM to 6:30 PM IST</p>
              <p><strong>Country:</strong> India</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
